import './styles.scss';
import React, {Dispatch, useEffect, useState} from "react";

/* Types, Constants, Utils */
import Utils from "../../utils";
import * as Constants from "../../constants";

/* Bootstrap */
import {Form} from "react-bootstrap";

/* Components*/
import Switch from "../switch";

/* Redux */
import {INotification, INotificationItem, IUserState} from "../../types/redux/user";
import {addNotification, removeNotifications} from "../../redux/slices/user-slice";
import {addToast} from "../../redux/slices/toast-slice";
import {RootState} from "../../redux";
import {useDispatch, useSelector} from "react-redux";
import {AnyAction} from "@reduxjs/toolkit";
import {setLoginModalActive} from "../../redux/slices/login-modal-slice";

/* Api */
import NotificationService from "../../api/notifications";
import {IIndustryMenuItem} from "../industry-menu/interface";
import useError from "../../hooks/useError";

const NotificationsSettings = ():JSX.Element => {

  const userState: IUserState = useSelector<RootState, IUserState>(state => state.user);
  const [allNotifications, setAllNotifications] = useState<INotificationItem[]>([]);
  const dispatch:Dispatch<AnyAction> = useDispatch();

  /* hooks */
  const {handleError} = useError();

  useEffect(()=>{
    if (userState.loggedIn) {
      const _allNotifications: any = Constants.INDUSTRY_ITEMS.map((item: IIndustryMenuItem) => {
        const selected: INotification = userState.notifications.find((n:any)=> n.targetCode.toLowerCase() === item.industry)
        return {
          active: !!selected,
          label: item.label,
          targetCode: item.industry,
          type: Constants.INDUSTRY
        }
      })

      const index: number = _allNotifications.findIndex((n:any)=>n.targetCode === Constants.ALL_INDUSTRIES)
      _allNotifications.splice(index, 1);

      setAllNotifications(_allNotifications);
    }
  }, [userState.loggedIn, userState.notifications])


  const handleNotificationToggle = (id: string)=> {
    const notificationItem:INotificationItem = allNotifications.find(n=>n.targetCode === id);
    if (notificationItem.active) {
      const notificationId: number = userState.notifications.find(n => {
        return n.targetCode.toLowerCase() === notificationItem.targetCode.toLowerCase()
      }).id;
      const params: any = {
        notificationRequestIds: [notificationId].toString()
      }
      const msg: string = Utils.toTitleCase(notificationItem.targetCode) + ' notification deactivate.';
      NotificationService.deleteNotifications(params).then(response => {
        dispatch(removeNotifications([notificationId]));
        dispatch(addToast({
          bg: 'bg-success',
          msg: msg,
          id: -1
        }))
      }).catch(e => handleError(e))
    } else {
      NotificationService.createNotification({
        targetCode: notificationItem.targetCode.toUpperCase(),
        targetType: notificationItem.type.toUpperCase()
      }).then(response =>{
        const msg: string = Utils.toTitleCase(notificationItem.targetCode) + ' notification active.';
        dispatch(addToast({
          bg: 'bg-success',
          msg: msg,
          id: -1
        }))
        dispatch(addNotification(response[0]));
      }).catch(e=>{
        e = JSON.parse(JSON.stringify(e)); // status is not parsed correctly in raw error
        if ((e.status === 403) || (e.status === 401)) {
          dispatch(setLoginModalActive(true));
        } else {
          dispatch(addToast({
            bg: 'bg-danger',
            msg: Constants.ERROR_NOTIFICATION,
            id: -1
          }))
        }
      });
    }

    const index: number = allNotifications.findIndex(n=>n.targetCode === notificationItem.targetCode);
    const notificationItemClone: INotificationItem = {...notificationItem};
    const allNotificationsClone: INotificationItem[] = [...allNotifications];
    allNotificationsClone.splice(index, 1, notificationItemClone);

    setAllNotifications(allNotificationsClone);
  }

  return <div className={'notification-settings pt-2'}>
    <div className={'text-normal mt-2 border-bottom'}>
      <p className={'mb-2 mx-4'}><i className={'bi bi-bell me-2'}></i><b>Notifications Settings</b></p>
      <p className={'mt-1 mx-4'}>Get monthly updates on new documents</p>
    </div>
    {!userState.loggedIn &&
      <p className={'mt-2 mx-4'}>You must be logged for this feature.</p>}

    {userState.loggedIn && <Form noValidate>
      <ul className={'switches mx-0 border'}>
        {allNotifications.map((notificationItem:INotificationItem, i:number) =>{
          return (
            <li className={'border-bottom py-2'} key={i}>
              <div className={'switch-container d-flex justify-content-between my-1 mx-4'}>
                <div className={'label me-2 text-smaller'}><p>{notificationItem.label} Industry Documents</p></div>
                <Switch
                  id={notificationItem.targetCode}
                  checked={notificationItem.active}
                  toggle={()=>{handleNotificationToggle(notificationItem.targetCode)}}
                />
              </div>
            </li>
          )})}
      </ul>
    </Form>}
  </div>
}

export default NotificationsSettings;
